import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

interface ToggleSwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
  className?: string;
}

export function ToggleSwitch({
  checked,
  onCheckedChange,
  label,
  disabled = false,
  className = '',
}: ToggleSwitchProps) {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <Switch checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} />
      <Label className="cursor-pointer" onClick={() => !disabled && onCheckedChange(!checked)}>
        {label}
      </Label>
    </div>
  );
}
